import type { Company, CompanyFormState } from '../models/types';

export function createBlankCompanyForm(): CompanyFormState {
  return {
    name: '',
    legalName: '',
    country: '',
    industry: '',
    type: '',
    status: 'Active',
    revenue: 0,
    employees: 0,
    taxId: '',
    incorporatedYear: new Date().getFullYear(),
    contact: '',
    merchants: 0,
    acquirer: '',
  };
}

export function getMaxCompanyRevenue(companies: Company[]) {
  return Math.max(...companies.map((c) => c.revenue), 1);
}

export function normalizeCompanyForm(form: Partial<CompanyFormState>, id?: number): Company {
  return {
    id: id ?? Date.now(),
    name: String(form.name ?? ''),
    legalName: String(form.legalName ?? ''),
    country: String(form.country ?? ''),
    industry: String(form.industry ?? ''),
    type: String(form.type ?? ''),
    status: String(form.status ?? 'Active'),
    revenue: Number(form.revenue) || 0,
    employees: Number(form.employees) || 0,
    taxId: String(form.taxId ?? ''),
    incorporatedYear: Number(form.incorporatedYear) || new Date().getFullYear(),
    contact: String(form.contact ?? ''),
    merchants: Number(form.merchants) || 0,
    acquirer: String(form.acquirer ?? ''),
  };
}
